import React, { useEffect, Suspense, lazy, createElement } from 'react';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { PainPoints } from './components/PainPoints';
const ProductOverview = lazy(() => import('./components/ProductOverview').then(m => ({
  default: m.ProductOverview
})));
const TomoDetails = lazy(() => import('./components/TomoDetails').then(m => ({
  default: m.TomoDetails
})));
const Bonuses = lazy(() => import('./components/Bonuses').then(m => ({
  default: m.Bonuses
})));
const CountdownPricing = lazy(() => import('./components/CountdownPricing').then(m => ({
  default: m.CountdownPricing
})));
const KitScale = lazy(() => import('./components/KitScale').then(m => ({
  default: m.KitScale
})));
const MoreTestimonials = lazy(() => import('./components/MoreTestimonials').then(m => ({
  default: m.MoreTestimonials
})));
const Guarantee = lazy(() => import('./components/Guarantee').then(m => ({
  default: m.Guarantee
})));
const FAQ = lazy(() => import('./components/FAQ').then(m => ({
  default: m.FAQ
})));
const CostComparison = lazy(() => import('./components/CostComparison').then(m => ({
  default: m.CostComparison
})));
const FinalCTA = lazy(() => import('./components/FinalCTA').then(m => ({
  default: m.FinalCTA
})));
const SocialProofPopup = lazy(() => import('./components/SocialProofPopup').then(m => ({
  default: m.SocialProofPopup
})));
export function App() {
  useEffect(() => {
    // Meta description
    const meta = document.querySelector('meta[name="description"]') || document.createElement('meta');
    meta.setAttribute('name', 'description');
    meta.setAttribute('content', 'MegaPack Contador PRO — Automatizá tu estudio contable con IA, recuperá 15 horas semanales y duplicá tus honorarios en 90 días. Prompts, macros, protocolos y más para contadores argentinos.');
    if (!document.querySelector('meta[name="description"]')) document.head.appendChild(meta);
    // Preconnect for Google Fonts & CDN
    const addPreconnect = (href: string, crossOrigin?: boolean) => {
      if (!document.querySelector(`link[href="${href}"]`)) {
        const link = document.createElement('link');
        link.rel = 'preconnect';
        link.href = href;
        if (crossOrigin) link.crossOrigin = 'anonymous';
        document.head.appendChild(link);
      }
    };
    addPreconnect('https://fonts.googleapis.com');
    addPreconnect('https://fonts.gstatic.com', true);
    addPreconnect('https://cdn.magicpatterns.com');
    // Preload LCP image
    if (!document.querySelector('link[rel="preload"][as="image"]')) {
      const preload = document.createElement('link');
      preload.rel = 'preload';
      preload.as = 'image';
      preload.href = 'https://cdn.magicpatterns.com/uploads/6j3X1LG1Nai6f3Yz5T185s/ChatGPT_Image_21_abr_2026,_03_36_21_p.m..png';
      document.head.appendChild(preload);
    }
  }, []);
  return <div className="min-h-screen bg-brand-dark font-sans text-slate-200 selection:bg-brand-accent selection:text-brand-dark" data-id="element-0">
      <Suspense fallback={<div className="min-h-screen" data-id="element-2" />} data-id="element-1">
        <SocialProofPopup data-id="element-3" />
      </Suspense>
      <main data-id="element-4">
        <Hero data-id="element-5" />
        <SocialProof data-id="element-6" />
        <PainPoints data-id="element-7" />
        <Suspense fallback={<div className="min-h-[50vh]" data-id="element-9" />} data-id="element-8">
          <ProductOverview data-id="element-10" />
          <TomoDetails data-id="element-11" />
          <Bonuses data-id="element-12" />
          <CountdownPricing data-id="element-13" />
          <KitScale data-id="element-14" />
          <MoreTestimonials data-id="element-15" />
          <Guarantee data-id="element-16" />
          <FAQ data-id="element-17" />
          <CostComparison data-id="element-18" />
          <FinalCTA data-id="element-19" />
        </Suspense>
      </main>
    </div>;
}